import React, { useState, useEffect, useCallback } from "react";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import LayersIcon from "@mui/icons-material/Layers";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import MainLayout from "../Themes/MainLayout";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, parse } from "date-fns";
import { useNavigate } from "react-router-dom";
import FlagIcon from "@mui/icons-material/Flag";
import { ThemeProvider } from "@mui/material/styles";
import Table_theme from "../Themes/TableTheme";
import { getConfirmDeleteDialog } from "../Components/confirmDeleteDialog";
import { validatePhone } from "../utils/phoneValidator";
import FormThemes from "../Themes/FormThemes";
import {
  CssBaseline,
  Grid,
  Checkbox,
  FormControlLabel,
  Typography,
  Button,
  Alert,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  InputAdornment,
  TextField,
  Menu,
  MenuItem,
  Switch,
  Popover,
  FormControl,
  Pagination,
  Select,
  InputLabel,
  FormHelperText,
  OutlinedInput,
  Tooltip,
  Snackbar,
  Autocomplete,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { ReactComponent as DeleteIcon } from "../Icons/Delete.svg";
import { ReactComponent as SettingsIcon } from "../Icons/Settings.svg";
import EmployeeSalary from "../Components/EmployeeSalary";
import EmployeeProject from "../Components/EmployeeProject";
import LeaveRequest from "../Components/LeaveRequest";
import { Add, Search } from "@mui/icons-material";
import { useCurrentUser } from "../utils/useCurrentUser";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const columns = [
  "emp_id",
  "first_name",
  "last_name",
  "gender",
  "doj",
  "dob",
  "address_1",
  "city_1",
  "state_1",
  "postal_code_1",
  "address_2",
  "city_2",
  "state_2",
  "postal_code_2",
  "blood_group",
  "designation",
  "mobile_1",
  "mobile_2",
  "personal_email",
  "bfx_email",
  "shift_id",
  "insurance_flag",
  "mon_leave_flag",
  "special_alw_flag",
  "night_shift_alw_flag",
  "internet_alw_flag",
  "delete_flag",
  "country_1",
  "country_2",
];

const columnLabels = {
  emp_id: "Employee ID",
  first_name: "First Name",
  last_name: "Last Name",
  gender: "Gender",
  doj: "Date of Joining",
  dob: "Date of Birth",
  address_1: "Address 1",
  city_1: "City 1",
  state_1: "State 1",
  postal_code_1: "Postal Code 1",
  address_2: "Address 2",
  city_2: "City 2",
  state_2: "State 2",
  postal_code_2: "Postal Code 2",
  blood_group: "Blood Group",
  designation: "Designation",
  mobile_1: "Mobile 1",
  mobile_2: "Mobile 2",
  personal_email: "Personal Email",
  bfx_email: "BFX Email",
  shift_id: "Shift ID",
  insurance_flag: "Insurance Flag",
  mon_leave_flag: "Monday Leave Flag",
  special_alw_flag: "Special Allowance Flag",
  night_shift_alw_flag: "Night Shift Allowance Flag",
  internet_alw_flag: "Internet Allowance Flag",
  delete_flag: "Delete Flag",
  country_1: "Country 1",
  country_2: "Country 2",
};

function EmployeeDetails() {
  const [data, setData] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});
  const [designations, setDesignation] = useState([]);
  const [gender, setGender] = useState([]);
  const [shift_id, setShift_id] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [countryCodes, setCountryCodes] = useState([]);
  const [visibleCols, setVisibleCols] = useState({
    emp_id: true,
    first_name: true,
    last_name: true,
    designation: true,
    mobile_1: true,
    personal_email: true,
    address_1: true,
    city_1: true,
    ...Object.fromEntries(
      columns
        .filter(
          (c) =>
            ![
              "emp_id",
              "first_name",
              "last_name",
              "designation",
              "mobile_1",
              "personal_email",
              "address_1",
              "city_1",
            ].includes(c),
        )
        .map((c) => [c, false]),
    ),
  });
  const { empId, boId, roles, hasPermission } = useCurrentUser();
  const [filters, setFilters] = useState({ delete_flag: "ACTIVE" });
  const [filterAnchors, setFilterAnchors] = useState({});
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;
  const [openDialog, setOpenDialog] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    emp_id: "",
    first_name: "",
    last_name: "",
    gender: "",
    doj: null,
    dob: null,
    address_1: "",
    city_1: "",
    state_1: "",
    postal_code_1: "",
    blood_group: "",
    designation: "",
    mobile_1: "",
    mobile_2: "",
    personal_email: "",
    bfx_email: "",
    shift_id: "",
    insurance_flag: false,
    mon_leave_flag: "",
    special_alw_flag: false,
    night_shift_alw_flag: false,
    internet_alw_flag: false,
    delete_flag: "N",
    address_2: "",
    city_2: "",
    state_2: "",
    postal_code_2: "",
    created_by: empId,
    modified_by: empId,
    country_1: "",
    country_2: "",
  });
  const [alert, setAlert] = useState({ type: "", msg: "" });
  const [anchorSettings, setAnchorSettings] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [salaryDialogOpen, setSalaryDialogOpen] = useState(false);
  const [projectDialogOpen, setProjectDialogOpen] = useState(false);
  const [leaveDialogOpen, setLeaveDialogOpen] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [states2, setStates2] = useState([]);
  const [cities, setCities] = useState([]);
  const [cities2, setCities2] = useState([]);
  const [zipCodes, setZipCodes] = useState([]);
  const [zipCodes2, setZipCodes2] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedCityId, setSelectedCityId] = useState("");
  const [selectedStateId2, setSelectedStateId2] = useState("");
  const [selectedCityId2, setSelectedCityId2] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedCountryId2, setSelectedCountryId2] = useState("");

  useEffect(() => {
    // --- fetch once on page load ---
    const fetchDropdown = async (type, setter) => {
      try {
        const response = await fetch(`${BASE_URL}/commonVariables/${type}`);
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        if (Array.isArray(data)) {
          // Remove duplicates using Map (keeps first occurrence)
          const uniqueMap = new Map();
          data.forEach((item) => {
            if (!uniqueMap.has(item.variable_value)) {
              uniqueMap.set(item.variable_value, item);
            }
          });
          const uniqueData = Array.from(uniqueMap.values());
          setter(uniqueData);
        } else {
          throw new Error("Invalid dropdown data format received");
        }
      } catch (error) {
        console.error(`Error fetching ${type}:`, error);
        setSnackbarMsg(error.message || `Failed to load ${type}.`);
        setShowSnackbar(true);
      }
    };

    const fetchCountries = async () => {
      try {
        const res = await fetch(`${BASE_URL}/commonVariables/countries`);
        if (!res.ok) throw new Error("Failed to fetch countries");
        const data = await res.json();
        setCountries(data);
      } catch (err) {
        console.error("Error fetching countries:", err);
        setCountries([]);
      }
    };
    // call everything ONCE here
    fetchDropdown("GENDER", setGender);
    fetchDropdown("SHIFT_ID", setShift_id);
    fetchDropdown("DESIGNATION", setDesignation);
    fetchCountries();
  }, []);
  // ---------- DEPENDENT FETCH FUNCTIONS ----------
  const fetchStates = async (countryId) => {
    if (!countryId) {
      setStates([]);
      return;
    }

    try {
      const res = await fetch(
        `${BASE_URL}/commonVariables/states/${countryId}`,
      );
      const data = await res.json();
      setStates(data);
    } catch (err) {
      console.error("Error fetching states:", err);
      setStates([]);
    }
  };

  const fetchCities = async (stateId) => {
    if (!stateId) {
      setCities([]);
      return;
    }
    try {
      const res = await fetch(`${BASE_URL}/commonVariables/cities/${stateId}`);
      const data = await res.json();
      setCities(data);
    } catch (err) {
      console.error("Error fetching cities:", err);
      setCities([]);
    }
  };

  const fetchZipCodes = async (cityId) => {
    if (!cityId) return setZipCodes([]);
    try {
      const res = await fetch(
        `${BASE_URL}/commonVariables/zipcodes/${Number(cityId)}`,
      );
      const data = await res.json();
      setZipCodes(data);
    } catch (err) {
      console.error("Error fetching zip codes:", err);
      setZipCodes([]);
    }
  };

  const fetchStates2 = async (countryId) => {
    if (!countryId) {
      setStates2([]);
      return;
    }
    try {
      const res = await fetch(
        `${BASE_URL}/commonVariables/states/${countryId}`,
      );
      const data = await res.json();
      setStates2(data);
    } catch (err) {
      console.error("Error fetching states2:", err);
      setStates2([]);
    }
  };

  const fetchCities2 = async (stateId) => {
    if (!stateId) {
      setCities2([]);
      return;
    }
    try {
      const res = await fetch(`${BASE_URL}/commonVariables/cities/${stateId}`);
      const data = await res.json();
      setCities2(data);
    } catch (err) {
      console.error("Error fetching cities2:", err);
      setCities2([]);
    }
  };

  const fetchZipCodes2 = async (cityId) => {
    if (!cityId) {
      setZipCodes2([]);
      return;
    }
    try {
      const res = await fetch(
        `${BASE_URL}/commonVariables/zipcodes/${Number(cityId)}`,
      );
      if (!res.ok) throw new Error("Failed to fetch zip codes");
      const data = await res.json();
      setZipCodes2(data);
    } catch (err) {
      console.error("Error fetching zip codes 2:", err);
      setZipCodes2([]);
    }
  };

  useEffect(() => {
    if (selectedCountryId) {
      fetchStates(selectedCountryId);
    }
  }, [selectedCountryId]);

  useEffect(() => {
    if (selectedStateId) {
      fetchCities(selectedStateId);
    }
  }, [selectedStateId]);

  useEffect(() => {
    if (selectedCityId) {
      fetchZipCodes(selectedCityId);
    }
  }, [selectedCityId]);

  useEffect(() => {
    if (selectedCountryId2) {
      fetchStates2(selectedCountryId2);
    }
  }, [selectedCountryId2]);

  useEffect(() => {
    if (selectedStateId2) {
      fetchCities2(selectedStateId2);
    }
  }, [selectedStateId2]);

  useEffect(() => {
    if (selectedCityId2) {
      fetchZipCodes2(selectedCityId2);
    }
  }, [selectedCityId2]);

  const fetchData = useCallback(async () => {
    try {
      console.log("roles----->", roles);
      let res, json;

      const normalizeRoles = (roles) => {
        if (!roles) return [];
        return Array.isArray(roles)
          ? roles.map((r) => r.toLowerCase())
          : [roles.toLowerCase()];
      };

      const normalizedRoles = normalizeRoles(roles);

      // Check for privileged roles first (Admin/HR see all employees)
      if (
        Array.isArray(roles) &&
        [
          "admin",
          "admins",
          "hr",
          "hrs",
          "human resource",
          "human resources",
        ].some((role) => normalizedRoles.includes(role))
      ) {
        const query = new URLSearchParams({
          page,
          boId,
          ...filters,
        }).toString();
        res = await fetch(`${BASE_URL}/EmployeeDetails/paginated?${query}`);
        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Fetch failed with status ${res.status}: ${text}`);
        }
        json = await res.json();
        setData(Array.isArray(json.data) ? json.data : []);
        setTotalPages(Math.ceil(json.total / rowsPerPage) || 1);
      } else if (
        Array.isArray(roles) &&
        normalizedRoles.includes("employees")
      ) {
        // Regular employee sees only their own record
        const query = new URLSearchParams({ ...filters }).toString();
        res = await fetch(
          `${BASE_URL}/EmployeeDetails/${boId}/${empId}?${query}`,
        );
        if (res.status === 404) {
          setData([]);
          setAlert({ type: "info", msg: "No records found" });
          setTimeout(() => {
            setAlert({ type: "", msg: "" });
          }, 3000);
          setTotalPages(1);
          return;
        }
        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Fetch failed with status ${res.status}: ${text}`);
        }
        json = await res.json();
        // single record → put inside array so table rendering won't break
        setData(json ? [json] : []);
        setTotalPages(1);
      } else {
        // No access - no matching roles
        setData([]);
        setTotalPages(1);
      }
    } catch (err) {
      console.error("Error fetching employees:", err);
      setData([]);
      setTotalPages(1);
    }
  }, [page, filters, boId, roles, empId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  useEffect(() => {
    setPage(1);
  }, [filters]);

  useEffect(() => {
    const fetchCountryCodes = async () => {
      try {
        const res = await fetch(`${BASE_URL}/commonVariables/countryCodes`);
        const data = await res.json();
        setCountryCodes(data);
      } catch (err) {
        console.error("Error fetching country codes:", err);
      }
    };

    fetchCountryCodes();
  }, []);

  useEffect(() => {
    const fetchStatusFlags = async () => {
      try {
        const res = await fetch(`${BASE_URL}/commonVariables/statusFlag`);
        const data = await res.json();
        setStatusOptions(data); // [{ code: "ACTIVE", label: "Active" }, ...]

        // Set default to ACTIVE
        const activeOption = data.find((option) => option.code === "ACTIVE");
        if (activeOption) {
          setSelectedStatus(activeOption.code); // "ACTIVE"
          setFilters((prev) => ({
            ...prev,
            delete_flag: activeOption.code,
          }));
        }
      } catch (err) {
        console.error("Failed to fetch employee status flags:", err);
      }
    };

    fetchStatusFlags();
  }, []);

  const handleEdit = (emp) => {
    const mapGender = (gender) => {
      const genderMap = {
        M: "Male",
        F: "Female",
        1: "Male",
        2: "Female",
        Male: "Male",
        Female: "Female",
      };
      return genderMap[gender] || gender || "";
    };
    let countryId = "";
    let countryId2 = "";
    let stateId = "";
    let cityId = "";
    let stateId2 = "";
    let cityId2 = "";

    /* ---------- COUNTRY 1 ---------- */
    if (emp.country_1 && countries.length > 0) {
      const country = countries.find(
        (c) =>
          (c.name || "").trim().toLowerCase() ===
          (emp.country_1 || "").trim().toLowerCase(),
      );
      countryId = country ? country.id : "";
    }
    /* ---------- STATE / CITY 1 ---------- */
    if (emp.state_1 && states.length > 0) {
      const state = states.find(
        (s) =>
          (s.name || "").trim().toLowerCase() ===
          (emp.state_1 || "").trim().toLowerCase(),
      );
      stateId = state ? state.id : "";
      if (stateId && emp.city_1 && cities.length > 0) {
        const city = cities.find(
          (c) =>
            (c.name || "").trim().toLowerCase() ===
              (emp.city_1 || "").trim().toLowerCase() && c.state_id === stateId,
        );
        cityId = city ? city.id : "";
      }
    }
    /* ---------- COUNTRY 2 ---------- */
    if (emp.country_2 && countries.length > 0) {
      const country_2 = countries.find(
        (c) =>
          (c.name || "").trim().toLowerCase() ===
          (emp.country_2 || "").trim().toLowerCase(),
      );
      countryId2 = country_2 ? country_2.id : "";
    }

    /* ---------- STATE / CITY 2 ---------- */
    if (emp.state_2 && states.length > 0) {
      const state2 = states.find(
        (s) =>
          (s.name || "").trim().toLowerCase() ===
          (emp.state_2 || "").trim().toLowerCase(),
      );
      stateId2 = state2 ? state2.id : "";
      if (stateId2 && emp.city_2 && cities.length > 0) {
        const city2 = cities.find(
          (c) =>
            (c.name || "").trim().toLowerCase() ===
              (emp.city_2 || "").trim().toLowerCase() &&
            c.state_id === stateId2,
        );
        cityId2 = city2 ? city2.id : "";
      }
    }

    setFormData({
      bo_id: boId,
      emp_id: emp.emp_id || "",
      first_name: emp.first_name || "",
      last_name: emp.last_name || "",
      gender: mapGender(emp.gender),
      doj: emp.doj ? format(new Date(emp.doj), "MM/dd/yyyy") : "",
      dob: emp.dob ? format(new Date(emp.dob), "MM/dd/yyyy") : "",
      country_1: emp.country_1 || "",
      address_1: emp.address_1 || "",
      city_1: emp.city_1 || "",
      state_1: emp.state_1 || "",
      postal_code_1: emp.postal_code_1 || "",
      country_2: emp.country_1 || "",
      address_2: emp.address_2 || "",
      city_2: emp.city_2 || "",
      state_2: emp.state_2 || "",
      postal_code_2: emp.postal_code_2 || "",
      blood_group: emp.blood_group || "",
      designation: emp.designation || "",
      mobile_1: emp.mobile_1 || "",
      mobile_2: emp.mobile_2 || "",
      personal_email: emp.personal_email || "",
      bfx_email: emp.bfx_email || "",
      shift_id: emp.shift_id || "",
      insurance_flag: emp.insurance_flag === "Y",
      mon_leave_flag: emp.mon_leave_flag === "Y",
      special_alw_flag: emp.special_alw_flag === "Y",
      night_shift_alw_flag: emp.night_shift_alw_flag === "Y",
      internet_alw_flag: emp.internet_alw_flag === "Y",
      delete_flag: emp.delete_flag || "N",
      created_by: empId,
      modified_by: empId,
    });
    setSelectedCountryId(countryId);
    setSelectedStateId(stateId);
    setSelectedCityId(cityId);
    setSelectedCountryId2(countryId2);
    setSelectedStateId2(stateId2);
    setSelectedCityId2(cityId2);
    setIsEditing(true);
    setOpenDialog(true);
    setFieldErrors({});
  };

  const handleAdd = () => {
    setFormData({
      bo_id: boId,
      emp_id: "",
      first_name: "",
      last_name: "",
      gender: "",
      doj: "",
      dob: "",
      country_1: "",
      address_1: "",
      city_1: "",
      state_1: "",
      postal_code_1: "",
      blood_group: "",
      designation: "",
      mobile_1: "",
      mobile_2: "",
      personal_email: "",
      bfx_email: "",
      shift_id: "",
      insurance_flag: false,
      mon_leave_flag: "",
      special_alw_flag: false,
      night_shift_alw_flag: false,
      internet_alw_flag: false,
      delete_flag: "N",
      country_2: "",
      address_2: "",
      city_2: "",
      state_2: "",
      postal_code_2: "",
      created_by: empId,
      modified_by: empId,
    });
    setSelectedCountryId("");
    setSelectedStateId("");
    setSelectedCityId("");
    setSelectedStateId2("");
    setSelectedCountryId2("");
    setSelectedCityId2("");
    setIsEditing(false);
    setOpenDialog(true);
    setFormSubmitted(false);
    setFieldErrors({});
  };
  // Validation function
  const validateForm = useCallback(async () => {
    const errors = {};

    // Employee ID validation - only letters and numbers, no special characters
    if (!formData.emp_id) {
      errors.emp_id = "Employee ID is required";
    } else if (!/^[a-zA-Z0-9]+$/.test(formData.emp_id)) {
      errors.emp_id =
        "Employee ID can only contain letters and numbers (no special characters)";
    }

    // First Name validation
    if (!formData.first_name) {
      errors.first_name = "First Name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(formData.first_name)) {
      errors.first_name =
        "Only letters and spaces are allowed (no special characters)";
    }

    // Last Name validation
    if (!formData.last_name) {
      errors.last_name = "Last Name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(formData.last_name)) {
      errors.last_name =
        "Only letters and spaces are allowed (no special characters)";
    }

    if (!formData.gender) errors.gender = "Gender is required";

    // DOB validation
    if (!formData.dob) {
      errors.dob = "Date of Birth is required";
    }

    // DOJ validation
    if (!formData.doj) {
      errors.doj = "Date of Joining is required";
    }

    // Validate DOJ is at least 18 years after DOB
    if (formData.dob && formData.doj) {
      const dobDate = parse(formData.dob, "MM/dd/yyyy", new Date());
      const dojDate = parse(formData.doj, "MM/dd/yyyy", new Date());

      // Calculate the date when employee turns 18
      const minJoiningDate = new Date(dobDate);
      minJoiningDate.setFullYear(dobDate.getFullYear() + 18);

      // Check if DOJ is before the employee turns 18
      if (dojDate < minJoiningDate) {
        errors.doj =
          "Date of Joining must be after employee turns 18 years old";
      }
    }
    if (!formData.country_1) errors.country_1 = "Country 1 is required";
    if (!formData.address_1) errors.address_1 = "Address 1 is required";
    if (!formData.city_1) errors.city_1 = "City 1 is required";
    if (!formData.state_1) errors.state_1 = "State 1 is required";
    if (!formData.postal_code_1)
      errors.postal_code_1 = "Postal Code 1 is required";
    if (!formData.designation) errors.designation = "Designation is required";
    if (!formData.personal_email)
      errors.personal_email = "Personal Email is required";
    if (!formData.bfx_email) errors.bfx_email = "BFX Email is required";
    if (!formData.shift_id) errors.shift_id = "Shift ID is required";
    // Mobile 1 (Required)
    if (!formData.mobile_1) {
      errors.mobile_1 = "Mobile 1 is required";
    } else {
      const phone1Result = validatePhone(formData.mobile_1);
      if (!phone1Result.isValid) {
        errors.mobile_1 = phone1Result.error;
      }
    }
    // Mobile 2 (Optional)
    if (!formData.mobile_2) {
      const phone2Result = validatePhone(formData.mobile_2);
      if (!phone2Result.isValid) {
        errors.mobile_2 = phone2Result.error;
      }
    }

    if (
      formData.personal_email &&
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        formData.personal_email,
      )
    )
      errors.personal_email = "Invalid email format";

    if (
      formData.bfx_email &&
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        formData.bfx_email,
      )
    )
      errors.bfx_email = "Invalid BFX email format";

    // BFX Email domain validation - must be @bloomfieldx.com
    if (
      formData.bfx_email &&
      !formData.bfx_email.toLowerCase().endsWith("@bloomfieldx.com")
    )
      errors.bfx_email = "BFX Email must be a @bloomfieldx.com address";

    if (
      formData.state_1 &&
      !states.find((s) => s.state_name === formData.state_1)
    )
      errors.state_1 = "Invalid state selected";

    if (formData.city_1 && !cities.find((c) => c.city_name === formData.city_1))
      errors.city_1 = "Invalid city selected";

    // Allow manual postal code entry — no whitelist validation
    if (formData.postal_code_1 && !/^\d{6}$/.test(formData.postal_code_1))
      errors.postal_code_1 = "Postal code must be 6 digits";

    return errors;
  }, [formData, isEditing, states, cities, zipCodes]);

  useEffect(() => {
    if (!formSubmitted) return;

    const runValidation = async () => {
      const errors = await validateForm();
      setFieldErrors(errors);
    };

    runValidation();
  }, [formData, formSubmitted, validateForm]);

  const handleSave = async () => {
    setFormSubmitted(true);
    // 1 Frontend validation
    const errors = await validateForm();
    setFieldErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }
    try {
      const method = isEditing ? "PUT" : "POST";
      const url = isEditing
        ? `${BASE_URL}/EmployeeDetails/${boId}/${formData.emp_id}`
        : `${BASE_URL}/EmployeeDetails`;

      const payload = {
        bo_id: boId,
        emp_id: formData.emp_id,
        first_name: formData.first_name,
        last_name: formData.last_name,
        gender: formData.gender,
        doj: formData.doj ? format(formData.doj, "MM/dd/yyyy") : "",
        dob: formData.dob ? format(formData.dob, "MM/dd/yyyy") : "",
        country_1: formData.country_1,
        address_1: formData.address_1,
        city_1: formData.city_1,
        state_1: formData.state_1,
        postal_code_1: formData.postal_code_1,
        country_2: formData.country_2,
        address_2: formData.address_2 || "",
        city_2: formData.city_2 || "",
        state_2: formData.state_2 || "",
        postal_code_2: formData.postal_code_2 || "",
        blood_group: formData.blood_group || "",
        designation: formData.designation,
        mobile_1: formData.mobile_1 || "",
        mobile_2: formData.mobile_2 || "",
        personal_email: formData.personal_email,
        bfx_email: formData.bfx_email,
        shift_id: formData.shift_id,
        insurance_flag: formData.insurance_flag ? "Y" : "N",
        mon_leave_flag: formData.mon_leave_flag ? "Y" : "N",
        special_alw_flag: formData.special_alw_flag ? "Y" : "N",
        night_shift_alw_flag: formData.night_shift_alw_flag ? "Y" : "N",
        internet_alw_flag: formData.internet_alw_flag ? "Y" : "N",
        delete_flag: isEditing ? formData.delete_flag : "N",
        created_by: isEditing ? formData.created_by : empId,
        modified_by: empId,
      };
      // API call
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await res.json();
      // Backend error → Show Snackbar and keep dialog open
      if (!res.ok) {
        if (
          res.status === 400 &&
          result.message &&
          result.message.includes("already exists")
        ) {
          setFieldErrors((prev) => ({
            ...prev,
            emp_id: result.message || "Employee ID already exists",
          }));
          setFormSubmitted(true);
          return;
        }
        throw new Error(result.message || "Failed to save employee");
      }
      // Success
      await fetchData();
      setSnackbarMsg(
        isEditing
          ? "Employee Updated successfully!"
          : "Employee Added successfully!",
      );
      setSnackbarSeverity("success");
      setShowSnackbar(true);
      setOpenDialog(false);
      setFormSubmitted(false);
      setFieldErrors({});
    } catch (err) {
      console.error("Error saving employee:", err);
      setSnackbarMsg(err.message || "Failed to save employee");
      setSnackbarSeverity("error");
      setShowSnackbar(true);
    }
  };

  const handleDelete = async (emp) => {
    try {
      const res = await fetch(
        `${BASE_URL}/EmployeeDetails/${boId}/${emp.emp_id}`,
        {
          method: "DELETE",
        },
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Delete failed");
      await fetchData();
      setAlert({
        type: "success",
        msg: `${data.employee_name} was deleted successfully..`,
      });
      setTimeout(() => {
        setAlert({ type: "", msg: "" });
      }, 3000);
    } catch (err) {
      console.error(err);
      setAlert({ type: "error", msg: "Failed to delete employee" });
      setTimeout(() => {
        setAlert({ type: "", msg: "" });
      }, 3000);
    }
  };

  const confirmDelete = (employee) => {
    if (!employee || !employee.emp_id) {
      console.error("Invalid employee object passed to delete handler");
      return;
    }
    setSelectedEmployee({
      emp_id: employee.emp_id,
      bo_id: employee.bo_id,
      employee_name: `${employee.first_name} ${employee.last_name}`,
    });
    setDeleteDialogOpen(true);
  };

  const handleToggleFlag = async (emp) => {
    const updatedFlag = emp.delete_flag === "Y" ? "N" : "Y";
    setData(
      data.map((e) =>
        e.emp_id === emp.emp_id ? { ...e, delete_flag: updatedFlag } : e,
      ),
    );
    try {
      const res = await fetch(
        `${BASE_URL}/EmployeeDetails/${boId}/${emp.emp_id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            bo_id: boId,
            delete_flag: updatedFlag,
            modified_by: empId,
          }),
        },
      );
      const text = await res.text();
      if (!res.ok) throw new Error(`Toggle failed: ${text}`);
      await fetchData();
      setAlert({ type: "success", msg: "Toggle flag updated Successfully.." });
      setTimeout(() => {
        setAlert({ type: "", msg: "" });
      }, 3000);
    } catch (err) {
      console.error("Error toggling flag:", err);
      setData(
        data.map((e) =>
          e.emp_id === emp.emp_id ? { ...e, delete_flag: emp.delete_flag } : e,
        ),
      );
      setAlert({ type: "error", msg: "Failed to update delete flag" });
    }
  };

  const handleSalary = (emp) => {
    setSelectedEmployeeId(emp.emp_id);
    setSalaryDialogOpen(true);
  };

  const handleLeave = (emp) => {
    setSelectedEmployee({
      employeeId: emp.emp_id,
      employeeName: `${emp.first_name} ${emp.last_name}`,
    });
    setLeaveDialogOpen(true);
  };

  const handleProject = (emp) => {
    setSelectedEmployee({
      employeeId: emp.emp_id,
      employeeName: `${emp.first_name} ${emp.last_name}`,
    });
    setProjectDialogOpen(true);
  };

  const handleTimesheet = (emp) => {
    navigate(`/timesheet`);
  };

  const handleFilterOpen = (e, col) => {
    setFilterAnchors((prev) => ({ ...prev, [col]: e.currentTarget }));
  };

  const handleFilterClose = (col) => {
    setFilterAnchors((prev) => ({ ...prev, [col]: null }));
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    try {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return ""; // Handle invalid dates
      return format(date, "MM/dd/yyyy"); // Use date-fns to format as mm/dd/yyyy
    } catch {
      return "";
    }
  };

  return (
    <MainLayout>
      {alert.msg && (
        <Alert severity={alert.type} sx={{ mb: 2 }}>
          {alert.msg}
        </Alert>
      )}

      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        gap={1.5}
        mb={2}
      >
        <Button
          onClick={(e) => setAnchorSettings(e.currentTarget)}
          sx={{ minWidth: 0, p: 1 }}
        >
          <SettingsIcon />
        </Button>
        <Menu
          anchorEl={anchorSettings}
          open={Boolean(anchorSettings)}
          onClose={() => setAnchorSettings(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              mt: 1,
              p: 1,
              width: 250,
              maxHeight: 300,
              overflowY: "auto",
              borderRadius: 2,
            },
          }}
        >
          {columns
            .filter(
              (col) =>
                ![
                  "mon_leave_flag",
                  "delete_flag",
                  "created_at",
                  "created_by",
                  "created_on_date",
                  "modified_at",
                  "modified_by",
                  "modified_on_date",
                ].includes(col),
            )
            .map((col) => (
              <MenuItem key={col} disableGutters sx={{ p: 0, mb: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: 1.5,
                    px: 2,
                    py: 1,
                    backgroundColor: "#fff",
                    gap: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "0.8rem",
                      color: "#333",
                      fontWeight: "bold",
                    }}
                  >
                    {columnLabels[col]}
                  </Typography>
                  <Switch
                    size="small"
                    checked={visibleCols[col]}
                    onChange={(e) =>
                      setVisibleCols((prev) => ({
                        ...prev,
                        [col]: e.target.checked,
                      }))
                    }
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#2DB0E4",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                        { backgroundColor: "#2DB0E4" },
                    }}
                  />
                </Box>
              </MenuItem>
            ))}
        </Menu>
        {hasPermission("Employees", "Edit") && (
          <Button
            variant="contained"
            onClick={handleAdd}
            color="primary"
            sx={{
              fontWeight: "bold",
              borderRadius: "8px",
              px: 2.5,
              height: 36,
              backgroundColor: "#2DB0E4",
            }}
            startIcon={<Add />}
          >
            Add
          </Button>
        )}

        <TextField
          size="small"
          sx={{
            width: 250,
            "& input": { fontSize: 14 }, // input + placeholder
            "& input::placeholder": { fontSize: 12 }, // placeholder only
          }}
          placeholder="Search ..."
          value={filters.search || ""}
          onChange={(e) => {
            setFilters((prev) => ({ ...prev, search: e.target.value }));
            setPage(1);
          }}
          InputProps={{
            sx: { height: 36, paddingRight: 0 },
            startAdornment: (
              <InputAdornment position="start">
                <Search fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        {/* Status Dropdown */}
        <TextField
          select
          size="small"
          label="Status"
          value={filters.delete_flag} // Ensure default shows Active
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, delete_flag: e.target.value }))
          }
          sx={{
            width: 200,
            // Make height match the 36px of the search field
            "& .MuiInputBase-root": {
              height: 36,
            },

            // Fix vertical alignment of text
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              fontSize: 12,
              padding: "0 14px",
            },

            // Label font size
            "& .MuiInputLabel-root": { fontSize: "14px" },
          }}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                sx: {
                  "& .MuiMenuItem-root": {
                    fontSize: "14px",
                    minHeight: "32px",
                  },
                },
              },
            },
          }}
        >
          <MenuItem value="ALL">All</MenuItem>
          {statusOptions.map((opt) => (
            <MenuItem key={opt.code} value={opt.code}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Box sx={{ width: "100%", overflowX: "auto", px: 0, py: 2, mt: "-10px" }}>
        {getConfirmDeleteDialog({
          open: deleteDialogOpen,
          onClose: () => {
            setDeleteDialogOpen(false);
            setSelectedEmployee(null);
          },
          onConfirm: () => {
            handleDelete(selectedEmployee);
            setDeleteDialogOpen(false);
            setSelectedEmployee(null);
          },
          title: "Confirm Deletion",
          contentText: selectedEmployee
            ? `Are you sure you want to delete the employee ${selectedEmployee.employee_name}?`
            : "Are you sure you want to delete this Employee?",
        })}

        <ThemeProvider theme={Table_theme}>
          <CssBaseline />
          <TableContainer>
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Actions</TableCell>
                  {columns.map(
                    (col) =>
                      visibleCols[col] && (
                        <TableCell key={col}>
                          <Box display="flex" alignItems="center">
                            {columnLabels[col]}
                            <IconButton
                              size="small"
                              onClick={(e) => handleFilterOpen(e, col)}
                            >
                              <FilterListIcon fontSize="small" />
                            </IconButton>
                          </Box>
                          <Popover
                            open={!!filterAnchors[col]}
                            anchorEl={filterAnchors[col]}
                            onClose={() => handleFilterClose(col)}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                          >
                            <Box p={2} width={200}>
                              <TextField
                                size="small"
                                label={`Filter ${columnLabels[col]}`}
                                value={filters[col] || ""}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    [col]: e.target.value,
                                  })
                                }
                                fullWidth
                              />
                              <Box
                                mt={1}
                                display="flex"
                                justifyContent="space-between"
                                gap={1}
                              >
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => {
                                    handleFilterClose(col);
                                  }}
                                >
                                  Apply
                                </Button>
                                <Button
                                  size="small"
                                  color="secondary"
                                  onClick={() => {
                                    setFilters({ ...filters, [col]: "" });
                                    handleFilterClose(col);
                                  }}
                                >
                                  Clear
                                </Button>
                              </Box>
                            </Box>
                          </Popover>
                        </TableCell>
                      ),
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((emp) => (
                    <TableRow key={emp.emp_id}>
                      <TableCell>
                        <Box display="flex" gap={0.5} justifyContent="center">
                          <Box display="flex" gap={0.5} justifyContent="center">
                            <Tooltip
                              title={
                                hasPermission("Employees", "Edit")
                                  ? "Edit"
                                  : "No permission"
                              }
                            >
                              <span>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    hasPermission("Employees", "Edit") &&
                                    handleEdit(emp)
                                  }
                                  disabled={!hasPermission("Employees", "Edit")}
                                  sx={{
                                    color: hasPermission("Employees", "Edit")
                                      ? "#2DB0E4"
                                      : "#ccc",
                                  }}
                                >
                                  <EditOutlinedIcon sx={{ fontSize: "16px" }} />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip
                              title={
                                hasPermission("Employees", "Delete")
                                  ? "Delete"
                                  : "No permission"
                              }
                            >
                              <span>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    hasPermission("Employees", "Delete") &&
                                    confirmDelete(emp)
                                  }
                                  disabled={
                                    !hasPermission("Employees", "Delete")
                                  }
                                >
                                  <DeleteIcon
                                    sx={{
                                      color: hasPermission(
                                        "Employees",
                                        "Delete",
                                      )
                                        ? "red"
                                        : "#ccc",
                                      width: 15,
                                      height: 15,
                                    }}
                                  />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip
                              title={
                                hasPermission("Employees", "Edit")
                                  ? "Toggle Delete Flag"
                                  : "No permission"
                              }
                            >
                              <span>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    hasPermission("Employees", "Edit") &&
                                    handleToggleFlag(emp)
                                  }
                                  disabled={!hasPermission("Employees", "Edit")}
                                >
                                  <FlagIcon
                                    style={{
                                      color:
                                        emp.delete_flag === "N"
                                          ? "#2E9F50"
                                          : "#FF0C0C",
                                      transition: "color 0.2s",
                                      width: 17,
                                      height: 17,
                                      verticalAlign: "middle",
                                    }}
                                  />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip
                              title={
                                hasPermission("Employee Salaries", "Edit")
                                  ? "View Salary"
                                  : "No permission"
                              }
                            >
                              <span>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    hasPermission(
                                      "Employee Salaries",
                                      "Edit",
                                    ) && handleSalary(emp)
                                  }
                                  disabled={
                                    !hasPermission("Employee Salaries", "Edit")
                                  }
                                >
                                  {/* <PaidIcon sx={{ fontSize: 16, color: '#1A73E8',}} />  */}
                                  <AttachMoneyIcon
                                    sx={{ fontSize: 17, color: "#2c16f3ff" }}
                                  />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip
                              title={
                                hasPermission("Leave Request", "Edit")
                                  ? "Manage Leave"
                                  : "No permission"
                              }
                            >
                              <span>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    hasPermission("Leave Request", "Edit") &&
                                    handleLeave(emp)
                                  }
                                  disabled={
                                    !hasPermission("Leave Request", "Edit")
                                  }
                                >
                                  <AssignmentTurnedInIcon
                                    sx={{ fontSize: 16, color: "#f0a780ff" }}
                                  />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip
                              title={
                                hasPermission("Employee Projects", "Edit")
                                  ? "View Projects"
                                  : "No permission"
                              }
                            >
                              <span>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    hasPermission(
                                      "Employee Projects",
                                      "Edit",
                                    ) && handleProject(emp)
                                  }
                                  disabled={
                                    !hasPermission("Employee Projects", "Edit")
                                  }
                                >
                                  <LayersIcon
                                    sx={{ fontSize: 16, color: "#df6694ff" }}
                                  />
                                </IconButton>
                              </span>
                            </Tooltip>
                            <Tooltip
                              title={
                                hasPermission("Timesheet", "Edit")
                                  ? "View TimeSheet"
                                  : "No permission"
                              }
                            >
                              <span>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    hasPermission("Timesheet", "Edit") &&
                                    handleTimesheet(emp)
                                  }
                                  disabled={!hasPermission("Timesheet", "Edit")}
                                >
                                  <TaskAltIcon
                                    sx={{ fontSize: 15, color: "#064e6aff" }}
                                  />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </Box>
                        </Box>
                      </TableCell>
                      {columns.map(
                        (col) =>
                          visibleCols[col] && (
                            <TableCell key={col}>
                              {col === "doj" || col === "dob"
                                ? formatDate(emp[col])
                                : emp[col] || "-"}
                            </TableCell>
                          ),
                      )}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={
                        columns.filter((col) => visibleCols[col]).length + 1
                      }
                      align="center"
                    >
                      No matching data found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box display="flex" justifyContent="center" mt={2}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(e, v) => setPage(v)}
              color="primary"
              variant="outlined"
              shape="rounded"
              sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: "8px",
                  minWidth: "32px",
                  height: "32px",
                  fontSize: "14px",
                },
                "& .Mui-selected": {
                  backgroundColor: "#b3dbea !important",
                  color: "black",
                  fontWeight: "bold",
                },
                "& .MuiPaginationItem-ellipsis": { display: "none" },
              }}
            />
          </Box>
        </ThemeProvider>

        <ThemeProvider theme={FormThemes}>
          <CssBaseline />
          <Dialog
            open={openDialog}
            onClose={(event, reason) => {
              if (reason === "backdropClick") {
                return; // Prevent closing on backdrop click
              }
              setOpenDialog(false);
              setIsEditing(false);
              setFieldErrors({});
              setFormSubmitted(false);
            }}
            fullWidth
            maxWidth="sm"
            sx={{
              "& .MuiDialog-paper": {
                borderRadius: 5,
                width: "550px",
                overflow: "visible",
                maxWidth: "95vw",
                margin: "0 auto",
                backgroundColor: "#fff",
              },
            }}
          >
            <DialogTitle
              sx={{
                borderRadius: "12px",
                bgcolor: "#f5f5f5",
                p: 1,
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              {isEditing ? "Edit Employee" : "Add Employee"}
              <IconButton
                aria-label="close"
                onClick={() => {
                  setOpenDialog(false);
                  setIsEditing(false);
                  setFieldErrors({});
                  setFormSubmitted(false);
                }}
                sx={{ position: "absolute", right: 8, top: 5 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent
              sx={{
                p: "14px 32px",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                backgroundColor: "#fff",
                mt: 1,
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                {designations.length === 0 && !isEditing ? (
                  <Typography color="error">
                    No data available. Please try again later.
                  </Typography>
                ) : (
                  <Grid container spacing={1} justifyContent="normal">
                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        label="Employee ID"
                        name="emp_id"
                        value={formData.emp_id || ""}
                        onChange={(e) => {
                          const val = e.target.value.replace(
                            /[^a-zA-Z0-9]/g,
                            "",
                          );
                          setFormData({ ...formData, emp_id: val });
                        }}
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            "& legend": {
                              maxWidth: "70px", //  removes extra notch space
                            },
                          },
                          "& .MuiInputLabel-outlined": {
                            transform: "translate(12px, -9px) scale(0.75)",
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="dense"
                        error={formSubmitted && !!fieldErrors.emp_id}
                        helperText={formSubmitted ? fieldErrors.emp_id : ""}
                        disabled={isEditing}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        label="First Name"
                        name="first_name"
                        value={formData.first_name || ""}
                        onChange={(e) => {
                          const val = e.target.value.replace(
                            /[^a-zA-Z\s]/g,
                            "",
                          );
                          setFormData({
                            ...formData,
                            first_name: val,
                          });
                        }}
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            "& legend": {
                              maxWidth: "65px", //  removes extra notch space
                            },
                          },
                          "& .MuiInputLabel-outlined": {
                            transform: "translate(12px, -9px) scale(0.75)",
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="dense"
                        error={formSubmitted && !!fieldErrors.first_name}
                        helperText={formSubmitted ? fieldErrors.first_name : ""}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        label="Last Name"
                        name="last_name"
                        value={formData.last_name || ""}
                        onChange={(e) => {
                          const val = e.target.value.replace(
                            /[^a-zA-Z\s]/g,
                            "",
                          );
                          setFormData({
                            ...formData,
                            last_name: val,
                          });
                        }}
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            "& legend": {
                              maxWidth: "65px", //  removes extra notch space
                            },
                          },
                          "& .MuiInputLabel-outlined": {
                            transform: "translate(12px, -9px) scale(0.75)",
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="none"
                        error={formSubmitted && !!fieldErrors.last_name}
                        helperText={formSubmitted ? fieldErrors.last_name : ""}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        // variant="outlined"
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            "& legend": {
                              maxWidth: "45px", //  removes extra notch space
                            },
                          },
                          "& .MuiInputLabel-outlined": {
                            transform: "translate(12px, -9px) scale(0.75)",
                          },
                        }}
                        margin="none"
                        error={formSubmitted && !!fieldErrors.gender}
                      >
                        <InputLabel id="gender-label" shrink>
                          Gender *
                        </InputLabel>
                        <Select
                          labelId="gender-label"
                          name="gender"
                          value={formData.gender || ""}
                          onChange={(e) =>
                            setFormData({ ...formData, gender: e.target.value })
                          }
                          input={<OutlinedInput notched label="Gender *" />} // keeps label gap
                        >
                          {gender.map((gender) => (
                            <MenuItem
                              key={gender.variable_code}
                              value={gender.variable_value}
                              sx={{ fontSize: "12px" }}
                            >
                              {gender.variable_value}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {formSubmitted ? fieldErrors.gender : ""}
                        </FormHelperText>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Date of Joining "
                          value={
                            formData.doj
                              ? parse(formData.doj, "MM/dd/yyyy", new Date())
                              : null
                          }
                          onChange={(newValue) =>
                            setFormData({
                              ...formData,
                              doj: newValue
                                ? format(newValue, "MM/dd/yyyy")
                                : "",
                            })
                          }
                          format="MM/dd/yyyy"
                          slotProps={{
                            textField: {
                              required: true,
                              name: "doj",
                              placeholder: "MM/DD/YYYY",
                              InputLabelProps: { shrink: true },
                              InputProps: {
                                sx: {
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                  fontSize: "0.8rem",
                                  height: 35,
                                  "& .MuiInputLabel-root": {
                                    fontSize: "0.8rem",
                                    color: "#000000",
                                  },
                                  backgroundColor: "#fafafa",
                                },
                              },
                              sx: {
                                width: "230px",
                                "& .MuiInputBase-root": {
                                  minHeight: 35,
                                  fontSize: "12px",
                                  backgroundColor: "#fafafa",
                                  color: "#000000",
                                },
                              },
                              margin: "none",
                              error: formSubmitted && !!fieldErrors.doj,
                              helperText: formSubmitted ? fieldErrors.doj : "",
                            },
                            popper: {
                              disablePortal: true,
                              placement: "bottom-start",
                              sx: {
                                "& .MuiPaper-root.MuiPickersPopper-paper": {
                                  width: "fit-content !important", // shrink to content
                                  height: "fit-content !important",
                                  overflow: "hidden",
                                  padding: 0, // remove paper padding
                                  minWidth: "unset",
                                  minHeight: "unset",
                                },
                                "& .MuiPickersBasePicker-root": {
                                  padding: 0, // remove internal padding
                                  margin: 0,
                                  minWidth: "unset",
                                  minHeight: "unset",
                                },
                                "& .MuiDayCalendar-root": {
                                  padding: 0,
                                  margin: 0,
                                },
                                "& .MuiPickersCalendarHeader-root": {
                                  padding: "30px",
                                  fontSize: "0.7rem",
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          required
                          label="Date of Birth "
                          value={
                            formData.dob
                              ? parse(formData.dob, "MM/dd/yyyy", new Date())
                              : null
                          }
                          onChange={(newValue) =>
                            setFormData({
                              ...formData,
                              dob: newValue
                                ? format(newValue, "MM/dd/yyyy")
                                : "",
                            })
                          }
                          format="MM/dd/yyyy"
                          slotProps={{
                            textField: {
                              required: true,
                              name: "dob",
                              placeholder: "MM/DD/YYYY",
                              InputLabelProps: { shrink: true },
                              InputProps: {
                                sx: {
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                  fontSize: "0.8rem",
                                  height: 35,
                                  "& .MuiInputLabel-root": {
                                    fontSize: "0.8rem",
                                    color: "#000000",
                                  },
                                  backgroundColor: "#fafafa",
                                },
                              },
                              sx: {
                                width: "230px",
                              },
                              margin: "none",
                              "& .MuiInputBase-root": {
                                minHeight: 35,
                                fontSize: "12px",
                                backgroundColor: "#fafafa",
                                color: "#000000",
                              },
                              error: formSubmitted && !!fieldErrors.dob,
                              helperText: formSubmitted ? fieldErrors.dob : "",
                            },
                            popper: {
                              disablePortal: true,
                              placement: "bottom-end", // Changed to bottom-end for right alignment
                              modifiers: [
                                {
                                  name: "preventOverflow",
                                  options: {
                                    altAxis: true,
                                    padding: 0,
                                  },
                                },
                                {
                                  name: "flip",
                                  options: {
                                    enabled: true, // Disable flipping to keep it on the right
                                  },
                                },
                              ],
                              sx: {
                                position: "absolute !important", // Ensure fixed positioning
                                right: 0, // Align to the right edge of the Grid item
                                "& .MuiPaper-root.MuiPickersPopper-paper": {
                                  width: "150px",
                                  height: "fit-content",
                                  overflow: "hidden",
                                  padding: 0,
                                  minWidth: "unset",
                                  minHeight: "unset",
                                  margin: 0, // Remove any margin adjustments
                                },
                                "& .MuiPickersBasePicker-root": {
                                  padding: 0,
                                  margin: 0,
                                  minWidth: "unset",
                                  minHeight: "unset",
                                },
                                "& .MuiDayCalendar-root": {
                                  padding: 0,
                                  margin: 0,
                                },
                                "& .MuiPickersCalendarHeader-root": {
                                  padding: "30px",
                                  fontSize: "0.7rem",
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        label="Address 1"
                        name="address_1"
                        value={formData.address_1 || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            address_1: e.target.value,
                          })
                        }
                        multiline
                        minRows={2} // ensures at least 2 lines are visible
                        maxRows={2}
                        sx={{
                          width: "230px",
                          "& .MuiInputBase-root": {
                            alignItems: "flex-start",
                            whiteSpace: "normal", // allow wrapping
                            padding: "0",
                          },
                          "& .MuiInputBase-input": {
                            overflow: "auto", // Ensure scrollbar appears
                            padding: "8px",
                          },
                          "& .MuiInputLabel-root": {
                            transform: "translate(14px, -9px) scale(0.75)", // Adjust label position
                            transformOrigin: "top left",
                          },
                          "& .MuiOutlinedInput-root legend": {
                            maxWidth: "60px !important",
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="none"
                        error={formSubmitted && !!fieldErrors.address_1}
                        helperText={formSubmitted ? fieldErrors.address_1 : ""}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Address 2"
                        name="address_2"
                        value={formData.address_2 || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            address_2: e.target.value,
                          })
                        }
                        multiline
                        minRows={2} // ensures at least 2 lines are visible
                        maxRows={2}
                        sx={{
                          width: "230px",
                          "& .MuiInputBase-root": {
                            alignItems: "flex-start",
                            whiteSpace: "normal", // allow wrapping
                            padding: "0",
                          },
                          "& .MuiInputBase-input": {
                            overflowY: "auto", // Enable vertical scroll
                            padding: "8px",
                          },
                          "& .MuiInputLabel-root": {
                            transform: "translate(14px, -9px) scale(0.75)",
                            transformOrigin: "top left",
                          },
                          "& .MuiOutlinedInput-root legend": {
                            maxWidth: "55px !important",
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="none"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": { height: "35px" },
                        }}
                        margin="none"
                        error={formSubmitted && !!fieldErrors.country_1}
                      >
                        <InputLabel shrink>Country 1 *</InputLabel>

                        <Select
                          name="country_1"
                          value={formData.country_1 || ""}
                          onChange={(e) => {
                            const country = countries.find(
                              (c) => c.country_name === e.target.value,
                            );

                            setFormData({
                              ...formData,
                              country_1: e.target.value,
                              state_1: "",
                              city_1: "",
                              postal_code_1: "",
                            });

                            setSelectedCountryId(
                              country ? country.country_id : "",
                            );
                            setSelectedStateId("");
                            setSelectedCityId("");
                          }}
                          input={<OutlinedInput notched label="Country 1" />}
                        >
                          <MenuItem value=""></MenuItem>
                          {countries.map((country) => (
                            <MenuItem
                              key={country.country_id}
                              value={country.country_name}
                              sx={{ fontSize: "12px" }}
                            >
                              {country.country_name}
                            </MenuItem>
                          ))}
                        </Select>

                        <FormHelperText>
                          {formSubmitted ? fieldErrors.country_1 : ""}
                        </FormHelperText>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            "& legend": { maxWidth: "40px" },
                          },
                          "& .MuiInputLabel-outlined": {
                            transform: "translate(12px, -9px) scale(0.75)",
                          },
                        }}
                        error={formSubmitted && !!fieldErrors.country_2}
                      >
                        <InputLabel shrink>Country 2</InputLabel>
                        <Select
                          name="country_2"
                          value={formData.country_2 || ""}
                          onChange={(e) => {
                            const country = countries.find(
                              (c) => c.country_name === e.target.value,
                            );

                            setFormData({
                              ...formData,
                              country_2: e.target.value,
                              state_2: "",
                              city_2: "",
                              postal_code_2: "",
                            });

                            setSelectedCountryId2(
                              country ? country.country_id : "",
                            );
                            setSelectedStateId2("");
                            setSelectedCityId2("");
                          }}
                          input={<OutlinedInput notched label="Country 2" />}
                        >
                          <MenuItem value=""></MenuItem>
                          {countries.map((country) => (
                            <MenuItem
                              key={country.country_id}
                              value={country.country_name}
                              sx={{ fontSize: "12px" }}
                            >
                              {country.country_name}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {formSubmitted ? fieldErrors.country_2 : ""}
                        </FormHelperText>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                          },
                        }}
                        margin="none"
                        error={formSubmitted && !!fieldErrors.state_1}
                      >
                        <InputLabel shrink>State 1 *</InputLabel>
                        <Select
                          name="state_1"
                          value={formData.state_1 || ""}
                          onChange={(e) => {
                            const state = states.find(
                              (s) => s.state_name === e.target.value,
                            );

                            setFormData({
                              ...formData,
                              state_1: e.target.value,
                              city_1: "",
                              postal_code_1: "",
                            });

                            setSelectedStateId(state?.state_id || "");
                            setSelectedCityId("");
                          }}
                          input={<OutlinedInput notched label="State 1" />}
                        >
                          {states.map((state) => (
                            <MenuItem
                              key={state.state_id}
                              value={state.state_name}
                              sx={{ fontSize: "12px" }}
                            >
                              {state.state_name}
                            </MenuItem>
                          ))}
                        </Select>

                        <FormHelperText>
                          {formSubmitted ? fieldErrors.state_1 : ""}
                        </FormHelperText>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            "& legend": {
                              maxWidth: "40px", //  removes extra notch space
                            },
                          },
                          "& .MuiInputLabel-outlined": {
                            transform: "translate(12px, -9px) scale(0.75)",
                          },
                        }}
                        error={formSubmitted && !!fieldErrors.state_2}
                      >
                        <InputLabel shrink>State 2 </InputLabel>
                        <Select
                          name="state_2"
                          value={formData.state_2 || ""}
                          onChange={(e) => {
                            const state = states.find(
                              (s) => s.state_name === e.target.value,
                            );
                            setFormData({
                              ...formData,
                              state_2: e.target.value,
                              city_2: "",
                              postal_code_2: "",
                            });
                            setSelectedStateId2(state ? state.state_id : "");
                            setSelectedCityId2("");
                          }}
                          input={<OutlinedInput notched label="State 2" />}
                        >
                          {states2.map((state) => (
                            <MenuItem
                              key={state.state_id}
                              value={state.state_name}
                              sx={{ fontSize: "12px" }}
                            >
                              {state.state_name}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {formSubmitted ? fieldErrors.state_2 : ""}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                          },
                        }}
                        margin="none"
                        error={formSubmitted && !!fieldErrors.city_1}
                      >
                        <InputLabel shrink>City 1 *</InputLabel>
                        <Select
                          name="city_1"
                          value={formData.city_1 || ""}
                          onChange={(e) => {
                            const city = cities.find(
                              (c) => c.city_name === e.target.value,
                            );

                            setFormData({
                              ...formData,
                              city_1: e.target.value,
                              postal_code_1: "",
                            });

                            setSelectedCityId(city ? city.city_id : "");
                          }}
                          input={<OutlinedInput notched label="City 1" />}
                          disabled={!selectedStateId}
                        >
                          {cities.map((city) => (
                            <MenuItem
                              key={city.city_id}
                              value={city.city_name}
                              sx={{ fontSize: "12px" }}
                            >
                              {city.city_name}
                            </MenuItem>
                          ))}
                        </Select>

                        <FormHelperText>
                          {formSubmitted ? fieldErrors.city_1 : ""}
                        </FormHelperText>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <FormControl
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            "& legend": {
                              maxWidth: "35px", //  removes extra notch space
                            },
                          },
                          "& .MuiInputLabel-outlined": {
                            transform: "translate(12px, -9px) scale(0.75)",
                          },
                        }}
                        margin="none"
                        error={formSubmitted && !!fieldErrors.city_2}
                      >
                        <InputLabel shrink>City 2 </InputLabel>
                        <Select
                          name="city_2"
                          value={formData.city_2 || ""}
                          onChange={(e) => {
                            const city = cities.find(
                              (c) => c.city_name === e.target.value,
                            );
                            setFormData({
                              ...formData,
                              city_2: e.target.value,
                              postal_code_2: "",
                            });
                            setSelectedCityId2(city ? city.city_id : "");
                          }}
                          input={<OutlinedInput notched label="City 2" />}
                          disabled={!selectedStateId2}
                        >
                          <MenuItem value=""></MenuItem>

                          {cities.map((city) => (
                            <MenuItem
                              key={city.city_id}
                              value={city.city_name}
                              sx={{ fontSize: "12px" }}
                            >
                              {city.city_name}
                            </MenuItem>
                          ))}
                        </Select>

                        <FormHelperText>
                          {formSubmitted ? fieldErrors.city_2 : ""}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Autocomplete
                        freeSolo
                        options={zipCodes.map((z) => z.zip_code)}
                        value={formData.postal_code_1 || ""}
                        onInputChange={(_, newVal) =>
                          setFormData({
                            ...formData,
                            postal_code_1: newVal
                              .replace(/\D/g, "")
                              .slice(0, 6),
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Postal Code 1 *"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ ...params.inputProps, maxLength: 6 }}
                            error={formSubmitted && !!fieldErrors.postal_code_1}
                            helperText={
                              formSubmitted ? fieldErrors.postal_code_1 : ""
                            }
                            sx={{
                              width: "230px",
                              "& .MuiOutlinedInput-root": { height: "35px" },
                              "& .MuiInputLabel-outlined": {
                                transform: "translate(12px, -9px) scale(0.75)",
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Autocomplete
                        freeSolo
                        options={zipCodes2.map((z) => z.zip_code)}
                        value={formData.postal_code_2 || ""}
                        onInputChange={(_, newVal) =>
                          setFormData({
                            ...formData,
                            postal_code_2: newVal
                              .replace(/\D/g, "")
                              .slice(0, 6),
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Postal Code 2"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ ...params.inputProps, maxLength: 6 }}
                            error={formSubmitted && !!fieldErrors.postal_code_2}
                            helperText={
                              formSubmitted ? fieldErrors.postal_code_2 : ""
                            }
                            sx={{
                              width: "230px",
                              "& .MuiOutlinedInput-root": { height: "35px" },
                              "& .MuiInputLabel-outlined": {
                                transform: "translate(12px, -9px) scale(0.75)",
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Blood Group"
                        name="blood_group"
                        value={formData.blood_group || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            blood_group: e.target.value,
                          })
                        }
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            "& legend": {
                              maxWidth: "65px", //  removes extra notch space
                            },
                          },
                          "& .MuiInputLabel-outlined": {
                            transform: "translate(12px, -9px) scale(0.75)",
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="none"
                        error={formSubmitted && !!fieldErrors.blood_group}
                        helperText={
                          formSubmitted ? fieldErrors.blood_group : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            "& legend": {
                              maxWidth: "70px", //  removes extra notch space
                            },
                          },
                          "& .MuiInputLabel-outlined": {
                            transform: "translate(12px, -9px) scale(0.75)",
                          },
                        }}
                        margin="none"
                        error={formSubmitted && !!fieldErrors.designation}
                      >
                        <InputLabel shrink>Designation *</InputLabel>
                        <Select
                          name="designation"
                          value={formData.designation || ""}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              designation: e.target.value,
                            })
                          }
                          input={<OutlinedInput notched label="Designation" />}
                        >
                          {designations.map((desig) => (
                            <MenuItem
                              key={desig.variable_code}
                              value={desig.variable_code}
                              sx={{ fontSize: "12px" }}
                            >
                              {desig.variable_value}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {formSubmitted ? fieldErrors.designation : ""}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {(() => {
                        const field = "mobile_1";
                        const labelText = "Mobile 1*";
                        const phoneValue = formData[field] || "";

                        const extractedCode =
                          phoneValue.startsWith("+") && phoneValue.includes(" ")
                            ? phoneValue.split(" ")[0]
                            : countryCodes?.[0]?.label || "+91";

                        const extractedPhone =
                          phoneValue.startsWith("+") && phoneValue.includes(" ")
                            ? phoneValue.split(" ").slice(1).join("")
                            : "";

                        return (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: 1,
                              width: "230px",
                            }}
                          >
                            {/* Code dropdown */}
                            <FormControl
                              size="small"
                              sx={{
                                width: "80px",
                                mt: "4px",
                                "& .MuiInputBase-root": { height: "35px" },
                                "& .MuiSelect-select": {
                                  padding: "6px 20px 6px 16px",
                                },
                                "& legend": {
                                  maxWidth: "35px", //  fixes extra notch gap
                                },
                              }}
                            >
                              <InputLabel shrink>Code</InputLabel>
                              <Select
                                value={extractedCode}
                                onChange={(e) => {
                                  const newValue = `${e.target.value} ${extractedPhone}`;
                                  setFormData((prev) => ({
                                    ...prev,
                                    [field]: newValue,
                                  }));
                                  setFieldErrors((prev) => ({
                                    ...prev,
                                    [field]: "",
                                  }));
                                }}
                                input={<OutlinedInput notched label="Code" />}
                              >
                                {countryCodes?.map((c) => (
                                  <MenuItem
                                    key={c.code}
                                    value={c.label}
                                    sx={{ fontSize: 12 }}
                                  >
                                    {c.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            {/* Phone input */}
                            <TextField
                              size="small"
                              label={labelText}
                              value={extractedPhone}
                              onChange={(e) => {
                                const newValue = `${extractedCode} ${e.target.value.trim()}`;
                                setFormData((prev) => ({
                                  ...prev,
                                  [field]: newValue,
                                }));
                                setFieldErrors((prev) => ({
                                  ...prev,
                                  [field]: "",
                                }));
                              }}
                              error={formSubmitted && !!fieldErrors[field]}
                              helperText={
                                formSubmitted ? fieldErrors[field] : ""
                              }
                              InputLabelProps={{ shrink: true }}
                              sx={{
                                width: "150px",
                                mt: "4px",
                                "& .MuiInputBase-input": {
                                  fontSize: "14px",
                                  padding: "8px 8px",
                                },
                                "& .MuiInputLabel-root": { fontSize: "14px" },
                                "& .MuiFormHelperText-root": {
                                  whiteSpace: "normal",
                                  marginLeft: 0,
                                  lineHeight: 1.1,
                                },
                                "& legend": {
                                  maxWidth: "50px", //  fixes extra notch gap
                                },
                              }}
                            />
                          </Box>
                        );
                      })()}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {(() => {
                        const field = "mobile_2";
                        const labelText = "Mobile 2";
                        const phoneValue = formData[field] || "";

                        const extractedCode =
                          phoneValue.startsWith("+") && phoneValue.includes(" ")
                            ? phoneValue.split(" ")[0]
                            : countryCodes?.[0]?.label || "+91";

                        const extractedPhone =
                          phoneValue.startsWith("+") && phoneValue.includes(" ")
                            ? phoneValue.split(" ").slice(1).join("")
                            : "";

                        return (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: 1,
                              width: "230px",
                            }}
                          >
                            {/* Code dropdown */}
                            <FormControl
                              size="small"
                              sx={{
                                width: "80px",
                                mt: "4px",
                                "& .MuiInputBase-root": { height: "35px" },
                                "& .MuiSelect-select": {
                                  padding: "6px 20px 6px 16px",
                                },
                                "& legend": {
                                  maxWidth: "35px", //  fixes extra notch gap
                                },
                              }}
                            >
                              <InputLabel shrink>Code</InputLabel>
                              <Select
                                value={extractedCode}
                                onChange={(e) => {
                                  const newValue = `${e.target.value} ${extractedPhone}`;
                                  setFormData((prev) => ({
                                    ...prev,
                                    [field]: newValue,
                                  }));
                                  setFieldErrors((prev) => ({
                                    ...prev,
                                    [field]: "",
                                  }));
                                }}
                                input={<OutlinedInput notched label="Code" />}
                              >
                                {countryCodes?.map((c) => (
                                  <MenuItem
                                    key={c.code}
                                    value={c.label}
                                    sx={{ fontSize: 12 }}
                                  >
                                    {c.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            {/* Phone input */}
                            <TextField
                              size="small"
                              label={labelText}
                              value={extractedPhone}
                              onChange={(e) => {
                                const newValue = `${extractedCode} ${e.target.value.trim()}`;
                                setFormData((prev) => ({
                                  ...prev,
                                  [field]: newValue,
                                }));
                                setFieldErrors((prev) => ({
                                  ...prev,
                                  [field]: "",
                                }));
                              }}
                              error={formSubmitted && !!fieldErrors[field]}
                              helperText={
                                formSubmitted ? fieldErrors[field] : ""
                              }
                              InputLabelProps={{ shrink: true }}
                              sx={{
                                width: "150px",
                                mt: "4px",
                                "& .MuiInputBase-input": {
                                  fontSize: "14px",
                                  padding: "8px 12px",
                                },
                                "& .MuiInputLabel-root": { fontSize: "14px" },
                                "& .MuiFormHelperText-root": {
                                  whiteSpace: "normal",
                                  marginLeft: 0,
                                  lineHeight: 1.4,
                                },
                                "& legend": {
                                  maxWidth: "50px", //  fixes extra notch gap
                                },
                              }}
                            />
                          </Box>
                        );
                      })()}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        label="Personal Email"
                        name="personal_email"
                        value={formData.personal_email || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            personal_email: e.target.value,
                          })
                        }
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            "& legend": {
                              maxWidth: "80px", //  removes extra notch space
                            },
                          },
                          "& .MuiInputLabel-outlined": {
                            transform: "translate(12px, -9px) scale(0.75)",
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="none"
                        error={formSubmitted && !!fieldErrors.personal_email}
                        helperText={
                          formSubmitted ? fieldErrors.personal_email : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        label="BFX Email"
                        name="bfx_email"
                        value={formData.bfx_email || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            bfx_email: e.target.value,
                          })
                        }
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                            "& legend": {
                              maxWidth: "60px", //  removes extra notch space
                            },
                          },
                          "& .MuiInputLabel-outlined": {
                            transform: "translate(12px, -9px) scale(0.75)",
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                        margin="none"
                        error={formSubmitted && !!fieldErrors.bfx_email}
                        helperText={formSubmitted ? fieldErrors.bfx_email : ""}
                      />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                      <FormControl
                        sx={{
                          width: "230px",
                          "& .MuiOutlinedInput-root": {
                            height: "35px",
                          },
                        }}
                        margin="none"
                        error={formSubmitted && !!fieldErrors.shift_id}
                      >
                        <InputLabel shrink>Shift ID *</InputLabel>
                        <Select
                          name="shift_id"
                          value={formData.shift_id || ""}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              shift_id: e.target.value,
                            })
                          }
                          input={<OutlinedInput notched label="Shift ID" />}
                        >
                          {shift_id.map((shift) => (
                            <MenuItem
                              key={shift.variable_code}
                              value={shift.variable_code}
                              sx={{ fontSize: "12px" }}
                            >
                              {shift.variable_value}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {formSubmitted ? fieldErrors.shift_id : ""}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid container spacing={0.5} justifyContent="normal">
                      <Grid item xs={12} sm={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.insurance_flag}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  insurance_flag: e.target.checked,
                                })
                              }
                              name="insurance_flag"
                              sx={{ p: 0.5 }}
                            />
                          }
                          label="Insurance"
                          sx={{
                            width: "230px",
                            minHeight: "35px",
                            m: 0,
                            "& .MuiFormControlLabel-label": {
                              fontSize: "0.75rem", // smaller font
                              lineHeight: 0.5, // reduces vertical spacing
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.special_alw_flag}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  special_alw_flag: e.target.checked,
                                })
                              }
                              name="special_alw_flag"
                              sx={{ p: 0.5 }}
                            />
                          }
                          label="Special Allowance"
                          sx={{
                            width: "230px",
                            minHeight: "35px",
                            m: 0,
                            "& .MuiFormControlLabel-label": {
                              fontSize: "0.75rem", // smaller font
                              lineHeight: 0.5, // reduces vertical spacing
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.night_shift_alw_flag}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  night_shift_alw_flag: e.target.checked,
                                })
                              }
                              name="night_shift_alw_flag"
                              sx={{ p: 0.5 }}
                            />
                          }
                          label="Night Shift Allowance"
                          sx={{
                            width: "230px",
                            minHeight: "35px",
                            m: 0,
                            "& .MuiFormControlLabel-label": {
                              fontSize: "0.75rem", // smaller font
                              lineHeight: 0.5, // reduces vertical spacing
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.internet_alw_flag}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  internet_alw_flag: e.target.checked,
                                })
                              }
                              name="internet_alw_flag"
                              sx={{ p: 0.5 }}
                            />
                          }
                          label="Internet Allowance"
                          sx={{
                            width: "230px",
                            minHeight: "35px",
                            m: 0,
                            "& .MuiFormControlLabel-label": {
                              fontSize: "0.75rem", // smaller font
                              lineHeight: 0.5, // reduces vertical spacing
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </LocalizationProvider>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpenDialog(false);
                  setIsEditing(false);
                  setFieldErrors({});
                  setFormSubmitted(false);
                }}
                variant="outlined"
                color="inherit"
                sx={{ mr: 1, color: "#555", borderColor: "#ccc" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSave}
                variant="contained"
                color="primary"
                sx={{
                  ...(isEditing && {
                    backgroundColor: "#4CAF50",
                    "&:hover": { backgroundColor: "#45a049" },
                  }),
                }}
              >
                {isEditing ? "Update" : "Save"}
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={salaryDialogOpen}
            onClose={() => setSalaryDialogOpen(false)}
            fullWidth
            maxWidth="lg"
            sx={{
              "& .MuiDialog-paper": { borderRadius: 5, overflow: "visible" },
            }}
          >
            <EmployeeSalary
              open={salaryDialogOpen}
              onClose={() => setSalaryDialogOpen(false)}
              employeeId={selectedEmployeeId}
            />
          </Dialog>
          <Dialog
            open={projectDialogOpen}
            onClose={() => setProjectDialogOpen(false)}
            fullWidth
            maxWidth="sm"
            sx={{
              "& .MuiDialog-paper": { borderRadius: 5, overflow: "visible" },
            }}
          >
            <EmployeeProject
              open={projectDialogOpen}
              onClose={() => setProjectDialogOpen(false)}
              employeeId={selectedEmployee?.employeeId}
              employeeName={selectedEmployee?.employeeName}
            />
          </Dialog>
          <Dialog
            open={leaveDialogOpen}
            onClose={() => setLeaveDialogOpen(false)}
            fullWidth
            maxWidth="lg"
            sx={{
              "& .MuiDialog-paper": { borderRadius: 5, overflow: "visible" },
            }}
          >
            <LeaveRequest
              open={leaveDialogOpen}
              onClose={() => setLeaveDialogOpen(false)}
              employeeId={selectedEmployee?.employeeId}
              employeeName={selectedEmployee?.employeeName}
            />
          </Dialog>
          <Snackbar
            open={showSnackbar}
            autoHideDuration={3000}
            onClose={() => setShowSnackbar(false)}
            message={snackbarMsg}
          >
            <Alert
              onClose={() => setShowSnackbar(false)}
              severity={snackbarSeverity}
              sx={{ width: "100%" }}
            >
              {snackbarMsg}
            </Alert>
          </Snackbar>
        </ThemeProvider>
      </Box>
    </MainLayout>
  );
}

export default EmployeeDetails;
